import clsx from "clsx";
import React from "react";
import "./faTableActionRow.scss";

interface FaTableActionRowProps extends React.ComponentPropsWithoutRef<"div"> { }

export function FaTableActionRow(props: FaTableActionRowProps) {
    return <div {...props} className={clsx("fa-table-action-row", props.className)} />;
}
